/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Anonymous users locally are "guest" with an empty user_id.
 * Anonymous users on production are "none".
 */
export enum UserRoles {
  Admin = 'admin',
  Collaborator = 'collaborator',
  Empty = '',
  Guest = 'guest',
  None = 'none',
  Owner = 'owner'
}

export type UserDevices = 'mobile-view' | 'tablet-view' | 'desktop-view';

/**
 * Added in app/views/shared/_js_globals.html.erb
 */
export interface CurrentUser {
  authorizedAsGuest: boolean | null;
  device: UserDevices;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRoles;
  scope: string;
  su: boolean;
  user_id: string;
}

export interface User {
  email: string;
  first_name?: string; // may not present on InsightsSession for an event
  last_name?: string; // may not present on InsightsSession for an event
  superuser?: boolean; // may not present on InsightsSession for an event
  user_key?: string; // may not present on InsightsSession for an event
}
